import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=d5851712&scoped=true&lang=pug"
import script from "./SendMessage.vue?vue&type=script&lang=ts"
export * from "./SendMessage.vue?vue&type=script&lang=ts"
import style0 from "./SendMessage.vue?vue&type=style&index=0&id=d5851712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5851712",
  null
  
)

export default component.exports